<style scoped>
	.send-tec{
    width:154px;
    height:36px;
    display: block;
    background:linear-gradient(0deg,rgba(5,115,203,1) 0%,rgba(63,159,234,1) 100%);
    border-radius:2px;
    line-height: 36px;
    font-size: 14px;
    color: #fff;
    position: absolute;
    top: calc(50% - 18px);
    left: 20px;
  }
  /*  c-question  */
  .c-question{
    padding: 6px 13px;
    text-align: left;
  }
  .c-status{
    color: #26AFFD;
  }
  /*  */
  .btn.col-btn-2{
    border: 1px solid #999999;
    color: #999999;
  }
  /* model box */
  .content-model-box{
    width:650px;
    height:500px;
    background:#FFFFFF;
    box-shadow: 1px 1px 10px 0 rgba(255,255,255,1);
    border-radius: 5px;
    margin-top: 120px;
  }
  .content-model-box>.top-title{
    height: 40px;
    line-height: 40px;
    text-align: left;
    background:rgba(243,243,243,1);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding-left: 20px;
    font-size: 16px;
    position: relative;
  }
  .content-model-box>.top-title>.close-btn{
    position: absolute;
    right: 10px;
    top: 0;
    cursor: pointer;
  }
  .content-model-box>.top-title>.close-btn:hover{
    color: #DF402D;
  }

  .content-model-box>.from-box{
    display: flex;
    flex-direction: column;
    max-height: calc(100% - 40px);
    overflow: auto;
    padding: 0 20px;
  }
  .content-model-box>.from-box>.from-col{
    display: flex;
    justify-content: flex-start;
    margin: 8px 0;
  }
  .content-model-box>.from-box>.from-col>.from-title{
    width: 100px !important;
    text-align: right;
    padding-right: 20px !important;
  }
  .radio-list .el-radio-group{
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .flex1{
	  flex:1;
  }
  .red{
	  color: red;
  }
</style>

<!--远程技术支持-->
<template>
	<SecondaryPageComponent :type-list="$t('tab.longrange')" :type-change-event="typeChange">
		<!-- 插槽主体内容 -->
		<div class="collection-table" slot="content-slot">
			<div class="c-t-head">
				<div v-for="item in thead" class="col" :class="item.width + ' ' + item.align" :key="index">{{item.title}}</div>
			</div>
			<div class="c-t-body">
				<div class="row" v-if="dataList.length <= 0"><span class="none-data">{{$t('technology.noData')}}...</span></div>
				<div v-if="dataList.length > 0" class="row" v-for="(outItem,outIndex) in dataList" :key="index">
					<div v-for="(item,index) in thead" class="col" :class="item.width + ' ' + item.align" :key="index">
						<!--col 1-->
						<template v-if="index === 0">
							<span class="c-question " :title="outItem.remark1">
								{{outItem.remark1.length > 10 ? (outItem.remark1.substring(0,10) + '...')
                : outItem.remark1}}
							</span>
						</template>
						<!--col 2-->
						<template v-if="index === 1">
							<span>{{outItem.scheduled}}</span>
						</template>
						<!--col 3-->
						<template v-if="index === 2">
							<div>
								<p>{{outItem.communication === 1 ? $t('technology.video') : outItem.communication === 2 ? $t('technology.tel') : $t('technology.communicate')}}</p>
								<p v-if="outItem.communication  !== 3">({{outItem.communicationRemark.length > 10 ? (outItem.communicationRemark.substring(0,10) + '...'):outItem.communicationRemark}})</p>
							</div>
						</template>
						<!--col -->
						<template v-if="index === 3">
							<span>{{outItem.languageType == 1 ? $t('technology.chinese'):$t('technology.english')}}</span>
						</template>
						<!--col 4-->
						<template v-if="index === 4">
							<span class="c-question remark" :title="outItem.remark">
								{{!!outItem.remark
                ? (outItem.remark.length > 10 ? (outItem.remark.substring(0,10) + '...') : outItem.remark)
                : '-'}}
							</span>
						</template>
						<!--col 5-->
						<template v-if="index === 5">
							<span class="c-status">
								{{outItem.auditStatus === 0
                ? $t('technology.no') : outItem.auditStatus === 1
                ? $t('technology.Accepted') : outItem.auditStatus === 2
                ? $t('technology.Completed') : $t('technology.Cancelled')}}
							</span>
						</template>
						<!--col 6-->
						<template v-if="index === 6">
							<div class="btn-col">
								<a @click="cancelBtn(outIndex)" v-if="[0,1].includes(outItem.auditStatus)" class="btn" href="javascript:void(0)">{{$t('technology.cancel')}}</a>
								<a @click="editBtn(outIndex)" v-if="outItem.auditStatus < 1" class="btn col-btn-2" href="javascript:void(0)">{{$t('technology.edit')}}</a>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>

		<!-- page 分页 插槽内容 -->
		<div class="page-component" slot="pager-slot">
			<!--发起-->
			<a class="send-tec" @click="sendTec">{{$t('technology.launch')}}</a>
			<!--pager-->
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
			 :total="totalDataCounts">
			</el-pagination>
		</div>

		<!--模态框-->
		<ModelPop v-if="showModel" slot="model-slot">
			<div class="content-model-box">
				<div class="top-title">
					<span>{{modelType === 1 ? $t('technology.launch') : $t('technology.edit')}} {{$t('technology.longrange')}}</span>
					<span class="close-btn" @click="() => showModel = false ">{{$t('technology.close')}}</span>
				</div>
				<div class="from-box">
					<div class="from-col">
						<p class="from-title"><span class="red">*</span>{{dataTitleGroup.remark1}}：</p>
						<div class="flex1">
							<el-input type="textarea" :rows="3" maxlength="500" show-word-limit resize="none" :placeholder="$t('technology.input')"
							 v-model="dataGroup.remark1"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"><span class="red">*</span>{{dataTitleGroup.communication}}：</p>
						<div class="radio-list">
							<el-radio-group v-model="dataGroup.communication">
								<el-radio v-for="item in dictCtype" :label="item.dictValue" :key="index">{{item.dictLabel}}</el-radio>
							</el-radio-group>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"><span class="red">*</span>{{dataTitleGroup.language}}：</p>
						<div>
							<el-select v-model="voiceType" :placeholder="$t('technology.choice')" value="" @change="voice">
								<el-option v-for="item in dictTypeLang" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"><span class="red">*</span>{{dataTitleGroup.communicationRemark}}：</p>
						<div>
							<el-input :placeholder="$t('technology.input')" maxlength="50" type="text" v-model="dataGroup.communicationRemark"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"><span class="red">*</span>{{dataTitleGroup.scheduled}}：</p>
						<div class="block">
							<el-date-picker v-model="dataGroup.scheduled" align="right" type="date" :placeholder="$t('technology.choice')"
							 :picker-options="pickerOptions">
							</el-date-picker>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"><span style="color:#ff0000;">*</span>{{dataTitleGroup.remark}}：</p>
						<div class="flex1">
							<el-input resize="none" type="textarea" maxlength="500" show-word-limit :rows="3" :placeholder="$t('technology.input')"
							 v-model="dataGroup.remark"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"></p>
						<el-button type="primary" @click="submitData">{{$t('technology.Submit')}}</el-button>
					</div>
				</div>
			</div>
		</ModelPop>
	</SecondaryPageComponent>
</template>

<script>
	import '../../../assets/css/l-table.css';
	import SecondaryPageComponent from '../../assembly/SecondaryPageComponent';
	import ModelPop from '../../assembly/ModelPop';
	import utils from '../../../assets/js/utils';

	export default {
		name: "RemoteTechnology",
		components: {
			SecondaryPageComponent,
			ModelPop
		},
		data() {
			return {
				typeList: ['远程技术支持'],
				thead: [],
				dictCtype: [],
				dataObjLang: {},
				dictTypeLang: [],
				dataList: [],
				currentPage: 1,
				pageSize: 5,
				totalDataCounts: 0,
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() <= Date.now();
					}
				},
				editIndex: -1,
				modelType: 1,
				showModel: false,
				dataTitleGroup: {},
				dataGroup: {
					remark1: '',
					communication: '1',
					communicationRemark: '',
					scheduled: '',
					remark: '',
					languageType: ''
				},
				index: null,
				voiceType: ''
			};
		},
		created() {
			this.token = sessionStorage.getItem('token');
			this.thead = this.$t('technology.thead')
			this.dataTitleGroup = this.$t('technology.dataTitleGroup')
			this.loadData(1);
			this.loadDictCtype();
		},
		methods: {
			// 选择语言
			voice(e) {
				this.dataGroup.languageType = e
				this.voiceType = e == 1 ? '中文' : '英文'
			},
			//类型改变的时候
			typeChange(index) {
				
			},
			//当页码改变时
			handleCurrentChange(pageNum) {
				this.loadData(pageNum);
				this.currentPage = pageNum;
			},
			//提交数据
			submitData() {
				if (!this.checkData()) return;
				let data = {
					...this.dataGroup,
					token: this.token,
				};
				let url = 'api/remote/support/addRemoteSupport';
				if (this.modelType === 2) {
					data.supportId = this.dataList[this.editIndex].supportId;
					url = 'api/remote/support/editRemoteSupport';
				}
				this.$post(url, data).then(res => {
					if (res.code === 0) {
						this.showModel = false;
						this.loadData(this.currentPage);
						Object.keys(this.dataGroup).forEach(item => {
							this.dataGroup[item] = '';
						});
					}
				});
			},
			//校验参数
			checkData() {
				let dataGroup = this.dataGroup;
				let keys = Object.keys(dataGroup);
				for (const key of keys) {
					if (!(dataGroup[key] + '').trim()) {
						this.$message({
							type: 'warning',
							message: this.$t('Tips.fillin') + this.dataTitleGroup[key]
						});
						return;
					}
				}
				dataGroup.scheduled = utils.formatStringDate(dataGroup.scheduled, 'yyyy-MM-dd');
				this.dataGroup = dataGroup;
				return true;
			},
			//取消
			cancelBtn(index) {
				this.$post('api/remote/support/cancelRemoteSupport', {
					token: this.token,
					supportId: this.dataList[index].supportId
				}).then(res => {
					if (res.code === 0) this.dataList[index].auditStatus = 3;
				});
			},
			//编辑
			editBtn(index) {
				//TODO 编辑功能
				this.modelType = 2;
				this.showModel = true;
				this.editIndex = index;
				let editData = this.dataList[index];
				Object.keys(this.dataGroup).forEach(item => {
					this.dataGroup[item] = editData[item] + '';
				});
			},
			//发起远程技术支持
			sendTec() {
				this.modelType = 1;
				this.showModel = true;
				Object.keys(this.dataGroup).forEach(item => {
					this.dataGroup[item] = '';
				});
			},
			//加载数据
			loadData(pageNum) {
				this.$get('api/remote/support/remoteSupportList', {
					token: this.token,
					pageSize: this.pageSize,
					pageNum
				}).then(res => {
					let dictTypeLang = res.params.dictType,
						dataObjLang = {};
					this.dictTypeLang = dictTypeLang;
					for (const item of dictTypeLang) dataObjLang['d' + item.dictValue] = item.dictLabel;
					this.dataObjLang = dataObjLang;
					let resData = res.data;
					resData.forEach(item => {
						if (!!item.scheduled) {
							item.scheduled = utils.formatStringDate(item.scheduled, 'yyyy-MM-dd');
							return;
						}
						item.scheduled = '';
					});
					this.dataList = resData;
					this.totalDataCounts = res.params.totalDataCounts;
				});
			},
			/**
			 * 加载类型
			 */
			loadDictCtype() {
				this.$post('api/remote/support/ctype/list', {
					token: sessionStorage.getItem('token')
				}).then(res => {
					this.dictCtype = res.data;
				});
			}

		}
	}
</script>



// WEBPACK FOOTER //
// src/components/memberCenter/remoteTechnology/RemoteTechnology.vue